<template>
	<v-container fluid class="pa-0">
		<v-row class="pt-0">
			<v-col cols="12" class="pt-0">
				<v-carousel
					cycle
					:height="$vuetify.breakpoint.smAndDown ? '250px' : '60vh'"
					hide-delimiter-background
					:show-arrows="sliders > 1 ? true : false"
				>
					<v-carousel-item
						v-for="(slider, i) in sliders"
						:src="slider.img"
					>
						<v-row class="height-full" justify="center">
							<v-col
								cols="11"
								md="11"
								offset-md="1"
								class="d-flex flex-column justify-center height-full"
							>
								<span
									class="slide-title pa-0 ma-0 animate__animated animate__fadeInLeft"
								>
									Tienda en linea
								</span>

								<span
									class="slide-subtitle pa-0 ma-0 animate__animated animate__fadeInRight"
								>
									Pinturas Acuario
								</span>

								<p
									class="slide-paragraph pa-0 ma-0 mt-4 animate__animated animate__fadeInUp animate__delay-1s"
								>
									Conoce la gran variedad de productos que
									Pinturas Acuario tiene para ti. <br />
									¡Descubre la pintura ideal para tu proyecto!
								</p>
							</v-col>
						</v-row>
					</v-carousel-item>
				</v-carousel>
			</v-col>
		</v-row>

		<!-- Produst Lines Section -->
		<v-row justify="center">
			<v-col cols="12" md="10" class="d-flex justify-start">
				<span class="category-title">
					Nuestors productos
				</span>
			</v-col>
			<v-col cols="12" md="10">
				<!-- ProductLines Component -->
				<ProductLines />
			</v-col>
		</v-row>

		<!-- Parallax Section -->
		<v-row>
			<v-col cols="12">
				<v-parallax
					height="250"
					class="d-flex justify-center align-center text-center mt-5"
					src="https://apps.pinturasacuario.mx/assets/store/images/customer/cqctv.jpg"
				>
					<v-container>
						<v-row>
							<v-col cols="12">
								<h1
									:class="[
										$vuetify.breakpoint.smAndDown
											? 'display-1'
											: 'display-2',
										'font-weight-thin',
									]"
								>
									¡Colores que cambian tu vida!
								</h1>
							</v-col>
						</v-row>
					</v-container>
				</v-parallax>
			</v-col>
		</v-row>

		<v-row justify="center">
			<v-col cols="12" lg="10">
				<v-row>
					<v-col cols="12" class="d-flex justify-start">
						<span class="category-title">
							los productos numero uno.
						</span>
					</v-col>

					<v-col cols="12">
						<SlideGroup :products="ProductsTop"></SlideGroup>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<v-row justify="center">
			<v-col cols="12" md="10" class="d-flex justify-start">
				<span class="category-title">
					Tendencias e Inspiración
				</span>
			</v-col>

			<v-col cols="12" md="10">
				<v-row>
					<v-col cols="12" v-for="category in largeCategories">
						<LargeCard :category="category"></LargeCard>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import SimpleCardIcon from "@/components/Category/SimpleCardIcon";
import LargeCard from "@/components/Category/LargeCard";
import CardImage from "@/components/Category/CardImage";
import SlideGroup from "@/components/Carousel/SlideGroup";
import ProductLines from "@/components/Sections/Home/ProductLines";
import { mapGetters } from "vuex";

export default {
	name: "Index",

	components: {
		LargeCard,
		CardImage,

		SlideGroup,
		ProductLines,
		SimpleCardIcon,
	},

	data: () => ({
		sliders: [
			{
				img:
					"https://apps.pinturasacuario.mx/assets/store/images/customer/4335.jpg",
			},
		],

		largeCategories: [
			{
				name: "La útima tendencia para tu hogar",
				description: "Típs y combinaciones de color y texturas.",
				color: "cyan",
			},
			{
				name: "Impermeabilizantes",
				description:
					"Acriterm el impermeabilizante elastomérico formulado a base de resinas estiren-acrílicas de la más alta calidad.",
				color: "light-blue",
			},
		],
	}),

	computed: {
		...mapGetters(["getArticlersWhereId", "getProductsWhereId"]),

		ProductsTop() {
			return this.getProductsWhereId([13, 44, 31, 47, 75, 14, 29, 15]);
		},
	},
};
</script>

<style lang="css" scoped>
.slider-container {
	height: 100%;
	background-color: yellow;
	width: 100%;
}

.slider-container img {
	width: 100%;
}

.slide-title {
	font-size: 4rem;
}

.slide-subtitle {
	font-size: 2rem;
}

.slide-paragraph {
	font-size: 1.2rem;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
	.slide-title {
		font-size: 1.8rem;
	}

	.slide-subtitle {
		font-size: 1.1rem;
	}

	.slide-paragraph {
		font-size: 0.75rem;
		letter-spacing: 0.5px;
	}
}
</style>
